import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateContractStatusSlice = createSlice({
    name: "updateContractStatus",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateContractStatusSlice_actions = updateContractStatusSlice.actions;
export var fetchData = _updateContractStatusSlice_actions.fetchData, fetchDataSuccess = _updateContractStatusSlice_actions.fetchDataSuccess, fetchDataFailure = _updateContractStatusSlice_actions.fetchDataFailure, resetState = _updateContractStatusSlice_actions.resetState;
export default updateContractStatusSlice.reducer;
